import React from 'react';
import { Navbar } from '../components/Navbar';
import { AboutPage } from '../components/AboutPage';
import { Footer } from '../components/Footer';
export const About = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2329">
      <Navbar data-id="element-2330" />
      <AboutPage data-id="element-2331" />
      <Footer data-id="element-2332" />
    </div>;
};